import React, { useEffect } from "react";
import { Link as ScrollLink } from 'react-scroll';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import pic from "../assets/images/1.png";
import f from "../assets/images/f.png";
import r from "../assets/images/re.png";
import logo2 from "../assets/images/flutter.png";
import Typed from "typed.js";
import l from '../assets/images/l.png'
const Hero = () => {
  

  useEffect(() => {
    const options = {
      strings: ["Mobile Application Developer","Full Stack Web Developer", "Ui Ux Designer", "Web Developer"],
      typeSpeed: 40,
      backSpeed: 10,
      loop: true,
      showCursor: true,
    };

    const typed = new Typed(".typed-text", options);

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <>
      <br />
      <section id="hero">
      <div
        style={{ marginTop: "100px" }}
        className="mx-auto container-fluid  justify-content-center  "
      >
         <br /> 
        <div className="mx-auto row dflex justify-content-center mx-4">
          <div className="my-4 col-lg-5 col-m-6 col-sm-12 justify-content-center  ">
            <p
              style={{ fontSize: "24px", color: "rgb(219, 58, 0)" }}
              className=" justify-content-center "
            >
              Hello I'm
            </p>
            <h2 id="h"
              style={{fontSize: "45px",fontfamily: 'oswald' }}
              className="name justify-content-center"
            >
              Hafsa Waseem,
            </h2>
            <span style={{ fontSize: "32px", color: "brown" }}>
              {" "}
              <div
                className="typed-text"
                style={{
                  fontFamily: "",
                  color: "orangered",
                  fontSize: "32px",
                  display: "inline-block",
                }}
              ></div>
            </span>
            <div style={{ fontSize: "20px" }} className="my-3">
              I'm very{" "}
              <span style={{ color: "rgb(39, 168, 0)" }} className=" ">
                {" "}
                Passionate
              </span>{" "}
              and <span className="text-primary">Dedicated</span>
              <br />
            </div>
            <p className=""style={{ color: "rgb(107, 45, 0)", fontSize: "18px",  }}>
             3 years of hands-on experience in mobile app development,  <br/> Proficient in full-stack (PERN/MERN),<br/> Strong UI/UX design skills in Figma. <br/>
              
            </p>
            <div className="row dflex">
            
            {/* Use FontAwesomeIcon for the Facebook icon */}
            <div className="col-lg-12 col-md-6 col-sm-6 my-3">
              <a className=""
                
                href="https://www.linkedin.com/in/hafsa-qureshi-51aa93286/"
              >
            
                <FontAwesomeIcon id="hov" style={{width:'18px' ,height:'18px'}}  className="mx-1 p-2" icon={faLinkedinIn} />
              </a>
              <a
              
                href="https://github.com/HafsaQureshi1"
              >
                <FontAwesomeIcon id="hov" style={{width:'19px' ,height:'19px'}} className="mx-2 p-2" icon={faGithub} />
              </a>
             
            </div>
          </div>
          </div>
          
          <div className="col-lg-4 col-md-5 col-sm-12 position-relative my-4  justify-content-center text-center">
            <br />
            <div className="mx-5 my-4 float-area position-absolute top-0 start-50 translate-middle-y">
              <img
                style={{ width: "5rem" }}
                className="float-img"
                src={r}
                alt="Skytsunami"
              />
            </div>
            
            <div className="mx-5 my-4 float-area position-absolute top-0 start-150 translate-middle-y">
              <img className=" float-img" src={f} alt="Skytsunami" />
            </div>
           
            <img style={{width:'75%'}} className=" img-fluid" src={pic} alt="" />
            <div className="my-4 float-area position-absolute top-0 start-50 translate-middle-x">
              <img  className="img-fluid float-img" src={logo2} alt="Skytsunami" />
            </div>
          </div>
        </div>
       <br/>
     <br/>
 
  </div>
  </section>
    </>
  );
};

export default Hero;
